import React, { useRef, useEffect } from "react";
import { ClickedVideo } from "./chat-content";
import { VideoStream } from "./video-stream";
import { X } from "lucide-react";

interface VideoModalProps {
  clickedVideo: ClickedVideo;
  onClose: () => void;
}

export const VideoModal: React.FC<VideoModalProps> = ({ clickedVideo, onClose }) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  if (!clickedVideo.videoId) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-[9999] bg-black/90">
      <div ref={modalRef} className="relative w-1/2 h-[60%]">
         <button
          onClick={onClose}
          className="absolute -top-12 -right-12 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-black/50 text-white transition-all duration-200 hover:bg-black/70 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-white/50"
          aria-label="Close video"
        >
          <X size={20} />
        </button>

        <VideoStream
          videoId={clickedVideo.videoId}
          currentTime={clickedVideo.startTime}
          controls
          className="w-full h-full rounded-xl"
        />
      </div>
    </div>
  );
};
